import store from '@/store/index.js';
import Vue from 'vue';
import UploadfileItem from '../upload-file-item/index.vue';
export default {
  props: {
    size: {
      type: Number,
      default: 10
    },
    config: {
      type: Object,
      default: function () {
        return {
        };
      }
    },
    limit: {
      type: Number,
      default: 100
    },
    title: {
      type: String,
      default: '上传照片'
    },
    files: {
      type: Array,
      default: function () {
        return [];
      }
    },
    format: { // 需要新扩展的格式，数组形式传进来
      type: Array,
      default: function () {
        return [];
      }
    },
    action: {
      type: String,
      default: '/api/v1.0/chanquan/fast/batchUploadFile'
    },
    btnTit: {
      type: String,
      default: '点击上传'
    },
    bizType: {
      type: String,
      default: ''
    }
  },
  components: {
    UploadfileItem
  },
  data: () => {
    return {
      uploadLoading: false,
      imageUrl: '',
      imageError: '',
      hideUp: false,
      noHidden: true,
      wrapHeight: 0,
      delDialogitem: 0,
      imgLoad: false,
      upFileList: [], // 准备好要上传的list
      uploadData: {},
      time: null, // change事件是否结束 是否可以直接调手动上传事件（目前设置1.5s）
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };
  },
  created() {
    const token = store.getters.userInfo.accessToken;
    if (token) {
      this.headers['Authorization'] = token;
    }
    this.uploadData.bizType = this.bizType;
    if (this.files.length >= this.limit) {
      this.hideUp = true;
    }
  },

  watch: {
    files() {
      if (this.files.length >= this.limit) {
        console.log('达到最大峰值了');
        this.hideUp = true;
      }
    }
  },

  methods: {
    cancelFile(index) {
      let files = this.files;
      files.splice(index, 1);
      // console.log('删除');
      this.$refs.uploadCom.clearFiles(); // 清空上传列表
      this.$emit('upload', files);
    },

    // 上传文件只能添加五条
    uploadFileClick(event) {
      if (this.files.length > this.limit) {
        this.$message({
          type: 'error',
          message: `最多只允许上传${this.limit}项文件!`
        });
        event.stopPropagation();
        this.$refs.uploadCom.clearFiles(); // 清空上传列表
        return false;
      }
    },
    beforeUpload(file) {
      console.log('上传前before', file);
      const arr = ['png', 'jpg', 'jpeg', 'pdf', ...this.format];
      let fileType = file.type.substring(file.type.lastIndexOf('/') + 1);
      let fileName = file.name.substring(file.name.lastIndexOf('.') + 1);
      // 图片和后缀都必须为arr内所包含类型
      if (!arr.includes(fileType) || !arr.includes(fileName)) {
        // if (!arr.find(item => file.type.indexOf(item) !== -1)) {
        this.$errorMessage('文件只能是 png，jpg，jpeg，pdf 格式!');
        return false;
      }
      if (file.size / 1024 / 1024 > this.size) {
        this.$errorMessage('文件大小不能超过' + this.size + 'M');
        return false;
      }
    },
    changeFile(file, fileList) {
      this.hideUp = fileList.length >= this.limit;
      // console.log(file, fileList, this.files);
      this.uploadLoading = true;
      const arr = ['png', 'jpg', 'jpeg', 'pdf', ...this.format];
      let fileType = file.raw.type.substring(file.raw.type.lastIndexOf('/') + 1);
      let fileName = file.raw.name.substring(file.raw.name.lastIndexOf('.') + 1);
      // 图片和后缀都必须为arr内所包含类型
      if (!arr.includes(fileType) || !arr.includes(fileName)) {
        // if (!arr.find(item => file.type.indexOf(item) !== -1)) {
        this.$errorMessage('文件只能是 png，jpg，jpeg，pdf 格式!');
        this.uploadLoading = false;
        this.$refs.uploadCom.clearFiles(); // 清空上传列表
        return false;
      }
      if (file.size / 1024 / 1024 > this.size) {
        this.$errorMessage('文件大小不能超过' + this.size + 'M');
        this.uploadLoading = false;
        this.$refs.uploadCom.clearFiles(); // 清空上传列表
        return false;
      }

      // 防抖 高频触发后n秒内只会执行一次  再次触发重新计时,只会在最后一次真正执行程序，这时便拿到了此次上传的说有file
      clearTimeout(this.time);
      this.time = setTimeout(() => {
        this.time = null;
        // 过滤出符合条件的push进入待传列表
        this.upFileList = [];
        for (let item of fileList) {
          if (item.raw && (arr.includes(item.raw.name.substring(item.raw.name.lastIndexOf('.') + 1))) && (item.size / 1024 / 1024 < this.size)) {// 过滤掉不符合条件的
            this.upFileList.push(item.raw);
          }
        }
        /*  console.log('防抖 高频触发后n秒内只会执行一次  再次触发重新计时', 4444, file, fileList, this.upFileList);
         this.$refs.uploadCom.clearFiles(); // 上传完毕清空上传列表，应该在回调后再调用
         说明此时change了所有文件了 可以上传了, 此时先隐藏，准备区域，先有上传loading....显示
         此时拿到了所有的准备要上传的文件
         将文件打包一下，组装成list
         手动调用批量上传的方法，如果上传成功了，关闭loadding.....，update，展示台的最新的数据；old+new,失败的话，不更新
        */
        this.submitUpload();
      }, 1500);
    },
    // 上传事件
    submitUpload() {
      // console.log(this.upFileList, this.files);
      if (this.upFileList.length + this.files.length > this.limit) {
        this.$errorMessage(`最多只允许上传${this.limit}项文件！`);
        // this.$refs.uploadCom.abort();
        this.uploadLoading = false;
        this.$refs.uploadCom.clearFiles(); // 清空上传列表
        return false;
      }
      if (this.upFileList.length === 0) {
        this.$errorMessage('没有获取到文件，请选择文件后上传！');
        this.uploadLoading = false;
        return;
      }
      // 批量上传文件（走一个接口），一次提交上传时的，参数封装方法；
      var form = new FormData();
      this.upFileList.forEach(item => {
        form.append('files', item);
      });
      Vue.axios.post('/api/v1.0/chanquan/fast/batchUploadFile', form).then(res => {
        if (res.code === '0') {
          // console.log(9999, res);
          let fileList = res.data.map(item => {
            return {
              ossImgUrl: item.allPath,
              sourceImgUrl: item.fullPath,
              fileName: item.fileName || '未命名.pdf'
            };
          });
          fileList = [...this.files, ...fileList];
          this.$emit('upload', fileList); // 更新展示列表
          // this.$emit('fileList', fileList);
        }
      }).catch((error) => {
        console.log(error);
        // this.$errorMessage('上传异常');
      }).finally(() => {
        this.uploadLoading = false;
        this.$refs.uploadCom.clearFiles(); // 上传完毕清空上传列表，应该在回调后再调用
      });
    },
    handleExceed(files) {
      // console.log('文件数量溢出钩子', files);
      if ((parseInt(files.length) + parseInt(this.files.length)) > this.limit) {
        this.$errorMessage(`最多只允许添加${this.limit}项文件!`);
        this.$refs.uploadCom.clearFiles(); // 清空上传列表
        return false;
      }
      this.hideUp = true;
    },

    /* 以下代码,是用组件自动上传，（非自定义方法上传）可删除 */
    removePhotoItem(file, fileList) {
      // console.log('remove');
      const list = fileList.map(item => {
        return {
          ossImgUrl: item.ossImgUrl ? item.ossImgUrl : (item.response && item.response.data && item.response.data.allPath),
          sourceImgUrl: item.sourceImgUrl ? item.sourceImgUrl : item.response && item.response.data && item.response.data.fullPath
        };
      });
      this.hideUp = list.length >= this.limit;
      this.$emit('upload', list);
      this.$emit('fileList', fileList);
      console.log(fileList, 1);
    },
    handleUpload(file) {
      // 上传事件
      // console.log('上传事件', file);
      var fileObj = file.file;
      var form = new FormData();
      form.append('file', fileObj);
      Vue.axios.post('/api/v1.0/chanquan/fast/uploadFile', form).then(res => {
        if (res.code === '0') {
          file.onSuccess(res);
          let fileItem = {
            ossImgUrl: res.data && res.data.allPath,
            sourceImgUrl: res.data && res.data.fullPath,
            fileName: res.data && res.data.fileName || '123.pdf'
          };
          let fileList = [...this.files, fileItem];
          console.log(fileList);
          this.$emit('upload', fileList);
          // this.$emit('fileList', fileList);
        }
      }).catch((error) => {
        console.log(error);
        // this.$errorMessage('上传异常');
        file.onError(error);
      });
    },
    handleUpSuccess(response, file, fileList) {
      this.hideUp = fileList.length >= this.limit;
      // console.log(99999, response, file, fileList);
      const list = fileList.map(item => {
        return {
          ossImgUrl: item.ossImgUrl ? item.ossImgUrl : (item.response && item.response.data && item.response.data.allPath),
          sourceImgUrl: item.sourceImgUrl ? item.sourceImgUrl : (item.response && item.response.data && item.response.data.fullPath),
          name: item.name
        };
      });
      console.log(list);
      this.$emit('upload', list);
      // this.$emit('fileList', fileList);
    },
    handleUpError(error) {
      console.log(error);
      // this.$errorMessage(error.reason);
    }
  }
};
